const benefits = [
  {
    icon: 'ri-flashlight-line',
    title: 'Natural Energy Boost',
    desc: 'High iron and B-vitamins combat fatigue and help you feel alert all day — without caffeine.',
    color: 'bg-amber-50 border-amber-200',
    iconColor: 'text-amber-600',
    tag: 'Week 1–2',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Iron & Blood Health',
    desc: 'Contains 156% DV of iron per 100g — an exceptional choice for managing anaemia naturally.',
    color: 'bg-red-50 border-red-200',
    iconColor: 'text-red-500',
    tag: 'Weeks 4–8',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Stronger Immunity',
    desc: '7× more Vitamin C than oranges. Daily use supports your body\'s natural defences year-round.',
    color: 'bg-green-50 border-green-200',
    iconColor: 'text-green-600',
    tag: 'Weeks 3–6',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Bone & Joint Support',
    desc: '4× more calcium than milk. Critical for bone density, joint health, and preventing osteoporosis.',
    color: 'bg-teal-50 border-teal-200',
    iconColor: 'text-teal-600',
    tag: 'Weeks 4–8',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Skin & Hair Health',
    desc: 'Rich in vitamin A, E, and antioxidants that fight free radicals, reduce inflammation, and nourish skin.',
    color: 'bg-lime-50 border-lime-200',
    iconColor: 'text-lime-700',
    tag: 'Weeks 4–8',
  },
  {
    icon: 'ri-mental-health-line',
    title: 'Blood Sugar Balance',
    desc: 'Research shows moringa leaf compounds may help support healthy fasting glucose levels.',
    color: 'bg-orange-50 border-orange-200',
    iconColor: 'text-orange-600',
    tag: 'Weeks 6–10',
  },
];

export default function MoringaKeyBenefits() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center bg-green-50 text-green-700 text-xs font-semibold px-4 py-1.5 rounded-full border border-green-200 uppercase tracking-widest mb-4">
            <i className="ri-medal-line mr-2"></i>Health Benefits
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Does Moringa Actually Do?
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Each benefit is tied to specific nutrients in our powder and typical onset times from consistent daily use.
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b, i) => (
            <div
              key={i}
              className={`rounded-2xl border p-7 ${b.color} hover:-translate-y-1 transition-transform duration-300`}
            >
              <div className="flex items-start justify-between mb-4">
                <span className={`w-12 h-12 flex items-center justify-center rounded-xl bg-white ${b.iconColor}`}>
                  <i className={`${b.icon} text-2xl`}></i>
                </span>
                <span className="text-xs font-bold text-gray-400 bg-white/80 border border-gray-200 px-2.5 py-1 rounded-full">
                  {b.tag}
                </span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{b.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-xs text-gray-400 mt-10 max-w-2xl mx-auto">
          Results vary by individual. Moringa is a whole-food supplement, not a medicine. Onset labels indicate when most consistent users report noticeable changes. Always consult a healthcare professional if you have a medical condition.
        </p>
      </div>
    </section>
  );
}
